<template>
  <table class="age-chart-table">
    <tr>
      <td class="age-chart-table__date-time-header">
        {{dateTimeTitle}}
      </td>
      <td
        class="age-chart-table__views-header"
        v-for="(item) in headers"
        :key="`header${item}`"
      >
        {{item === "u" ? "Неизвестно" : item}}
      </td>
    </tr>

    <tr>
      <td class="age-chart-table__date-time">
        {{ageDate}}
      </td>

      <td
        v-for="(item, key) in ageData"
        class="age-chart-table__value"
        contenteditable="true"
        @keyup.enter="onEnter($event)"
        @blur="updateChartItem($event, key, item)"
        :key="key"
      >
        {{item}}
      </td>

    </tr>
  </table>
</template>

<script>
  // store
  import { UPDATE_AUDIT_CHART } from "../../../../../store/actions/audit";

  export default {
    name: "AgeTable",
    props: {
      data: {
        type: Object
      },
      chartName: {
        type: String
      }
    },
    computed: {
      dateTimeTitle() {
        return this.$t('feed.audit.edit.age.date');
      },
      headers(){
        return Object.keys(this.data.additional_data.age);
      },
      ageDate() {
        let from = this.data.from.split(" ");
        let to = this.data.to.split(" ");

        return `c ${from[0]} до ${to[0]}`;
      },
      ageData() {
        console.log(this.data);
        return this.data.additional_data.age;
      }
    },
    methods: {
      onEnter(event) {
        event.target.blur();
      },
      updateChartItem(event, index, key) {
        const value = parseInt(event.target.innerHTML.trim());
        event.target.innerHTML = value;

        this.$store.dispatch(UPDATE_AUDIT_CHART, {
          chart: this.chartName,
          value,
          index,
          key
        })
          .then(() => {
            this.$notify({
              title: this.$t('feed.audit.edit.notify.title'),
              message: this.$t('feed.audit.edit.notify.text'),
              type: 'success',
              duration: 1500,
              showClose: false
            });
          });
      }
    }
  }
</script>

<style>
  .age-chart-table {
    width: 100%;
    margin-top: 34px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    border-collapse: collapse;
  }

  .age-chart-table td {
    height: 40px;
    padding: 0 0 0 20px;
    border: 2px solid #EBEBEB;
    box-sizing: border-box;
  }

  .age-chart-table .age-chart-table__date-time-header {
    width: 20%;
    color: #5E6D82;
    border-left: transparent;
  }

  .age-chart-table__views-header {
    width: 20%;
    color: #5E6D82;
    cursor: default;
  }

  .age-chart-table .age-chart-table__views-header {
    border-right: transparent;
  }

  .age-chart-table .age-chart-table__value {
    border-right: transparent;
  }

  .age-chart-table .age-chart-table__date-time {
    border-left: transparent;
  }

  .age-chart-table__date-time,
  .age-chart-table__value {
    color: #5E6D82;
  }

  .age-chart-table__value {
    cursor: text;
  }

  .age-chart-table__value:hover {
    background-color: #f5f7fa;
  }

  .age-chart-table__value:focus {
    outline: none;
    background-color: #f5f7fa;
  }
</style>
